import { queryData } from '@/core/graphqlClient/queryClient';
import logger from '@/core/observability/logger';
import { getPlatform, isB2B } from '@/core/settings/utils';
import { Channel, PartnerAdSpace, Platform } from '@/generated/graphql/types';
import { PartnerAdBannerCampaign } from '@/sellerAdsManagement/PartnerAdBannerCampaign/interfaces/partnerAdBannerCampaign';

import { PartnerAdCampaignsListingMiddleCategoryDocument } from './graphql/PartnerAdCampaignsListingMiddleCategory/generated/partnerAdCampaignsListingMiddleCategory.query.generated';
import { PartnerAdCampaignsListingMiddleSearchDocument } from './graphql/PartnerAdCampaignsListingMiddleSearch/generated/partnerAdCampaignsListingMiddleSearch.query.generated';

export const fetchPartnerAdCampaignsListingMiddleCategory = (
  categoryIds: string,
  sessionId: string,
) => {
  const categoryIdsArray = categoryIds
    ? categoryIds.split(',').map((id) => parseInt(id, 10))
    : [];

  return queryData<PartnerAdBannerCampaign[]>(
    PartnerAdCampaignsListingMiddleCategoryDocument,
    {
      platform: getPlatform().toUpperCase() as Platform,
      market: isB2B() ? 'B2B' : 'B2C',
      channel: Channel.WEB,
      space: PartnerAdSpace.LISTING_MIDDLE_CATEGORY,
      sessionId,
      categoryIds: categoryIdsArray.length > 0 ? [categoryIdsArray[0]] : [],
    },
  )
    .then(
      (result: any) =>
        (result.partnerAdCampaigns?.listByCategories ??
          []) as PartnerAdBannerCampaign[],
    )
    .catch((e) => {
      logger.error(e.message);
      return [] as PartnerAdBannerCampaign[];
    });
};

export const fetchPartnerAdCampaignsListingMiddleSearch = (
  query: string,
  sessionId: string,
) => {
  return queryData<PartnerAdBannerCampaign[]>(
    PartnerAdCampaignsListingMiddleSearchDocument,
    {
      platform: getPlatform().toUpperCase() as Platform,
      market: isB2B() ? 'B2B' : 'B2C',
      channel: Channel.WEB,
      space: PartnerAdSpace.LISTING_MIDDLE_SEARCH,
      sessionId,
      query,
    },
  )
    .then(
      (result: any) =>
        (result.partnerAdCampaigns?.listByQuery ??
          []) as PartnerAdBannerCampaign[],
    )
    .catch((e) => {
      logger.error(e.message);
      return [] as PartnerAdBannerCampaign[];
    });
};
